import React, { useId } from "react";

const ToggleButton = ({ name, isToggleDisable, handleToggle, data }) => {
  const id1 = useId();
  const handleLocalChange = (e, data1) => {
    handleToggle(e, data1);
  };

  return (
    <div className="filter_toggle_btn2">
      <input
        id={id1}
        name={name && name}
        type="checkbox"
        checked={!isToggleDisable}
        onChange={(e) => {
          handleLocalChange(e, data);
        }}
      />
      <label htmlFor={id1}></label>
    </div>
  );
};

export default ToggleButton;
